import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useSettings } from "@/context/SettingsContext";

export const WhatsAppFloat = () => {
  const settings = useSettings();
  const number = (settings.whatsapp || settings.phone || "").replace(/[^0-9]/g, "");
  if (!number) return null;
  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    `Hi ${settings.company_name}! I'm interested in planning a trip.`
  )}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 14 }}
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 group-hover:scale-110 transition-transform duration-200">
        <MessageCircle size={26} strokeWidth={2} />
      </span>
      <span className="hidden md:block absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-card border border-gold/30 text-cream text-xs px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        Chat with us on WhatsApp
      </span>
    </motion.a>
  );
};
